import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordModule } from 'primeng/password';
import { FormFieldComponent } from '@shared/models/classes/FormFieldComponent';

@Component({
  standalone: true,
  selector: 'pm-form-field-password',
  imports: [PasswordModule, ReactiveFormsModule],
  templateUrl: './pm-form-field-password.component.html',
  styleUrl: './pm-form-field-password.component.scss',
})
export class PmFormFieldPasswordComponent extends FormFieldComponent {}
